// extracted by mini-css-extract-plugin
export default {"table":"oJrzSaU7x1JrG7z1MlZb"};